module.exports = __webpack_public_path__ + "files/8ae64d75e40d660b4cc4acc23208ec4c.png";